import { render, staticRenderFns } from "./SimpleTask.vue?vue&type=template&id=49cfba52&scoped=true&"
import script from "./SimpleTask.vue?vue&type=script&lang=js&"
export * from "./SimpleTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cfba52",
  null
  
)

export default component.exports